export const ActiveFlag = [
    {
        searchFlag: true,
        name: 'Todos',
        value: null,
    },
    {
        searchFlag: false,
        name: 'Sim',
        value: true,
    },
    {
        searchFlag: false,
        name: 'Não',
        value: false,
    }
];